module.exports = __webpack_public_path__ + "static/media/unknownPlayer.c6f578c9.png";